import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import HealthDetailMobile from '../Layout/DoctorDetailMobile';
import HealthDetailWeb from '../Layout/DoctorDetailWeb';

const ResponsiveHealthDetail = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed

  return (
    <>
      {isMobile ? <HealthDetailMobile /> : <HealthDetailWeb />}
    </>
  );
};

export default ResponsiveHealthDetail;